var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"text-center mb-4 p-4 bg-white rounded shadow-sm"},[_c('h1',{staticClass:"display-5 text-primary mb-2"},[_c('i',{staticClass:"fa-solid fa-book me-2"}),_vm._v("Aplikasi Stok Bahan Ajar SITTA")]),_c('p',{staticClass:"lead text-muted"},[_vm._v("Sistem Informasi Tracking dan Inventori Bahan Ajar")])])
}]

export { render, staticRenderFns }